<template>
  <div class="chat-content">
    <slot name="message-head"></slot>
    <!-- <div class="chat-item"  v-for="(item, index) in list" :key="index" v-if="!item.hidden"> -->
    <div class="chat-item"  v-for="(item, index) in list" :key="index" v-show="!item.hidden">
      <div class="message-time">{{ formatMessageTime(index) }}</div>
      <!-- 撤回的消息 -->
      <div v-if="item.status === 2" class="system-message">
        {{ item.fromAccount !== userInfo.userID ? $lang.customerWithdrew : $lang.youWithdrew  }}
      </div>
      <!-- 未撤回 -->
      <div class="message-outer" :class="{right : item.isMe}" v-else>
        <!-- 头像 -->
        <img :src="item.isMe ? require('../assets/img/yh_avatar.png') : $theme.kfImgUrl" alt="" class="avatar">
        <div class="message-detail-box" @touchstart="touchstart" @touchend="touchend($event, index)">
          <!-- 文本消息 -->
          <div class="text-message" v-if="item.messageType === 'TIMTextElem'" v-html="item.messageText"></div>
          <!-- 图片消息 -->
          <img @click="previewImg(item.imgUrl)" :src="item.imgUrl" alt="" class="img-message" v-if="item.messageType === 'TIMImageElem'">
          <!-- 文件消息 -->
          <el-tooltip class="item" effect="dark" :content="'点击去下载 ' + item.fileName" placement="top-start">
            <div class="file-message" v-if="item.messageType === 'TIMFileElem'" @click="toDownloadFile(item)">
              <i class="el-icon-folder"></i>
              <span class="file-name">{{item.fileName}}</span>
            </div>
          </el-tooltip>
          <!-- 视频消息 -->
          <video v-if="item.messageType === 'TIMVideoFileElem'" class="video-message" controls :src="item.videoUrl"></video>
          <!-- 自定义消息-课程卡片消息 -->
          <CourseSuspension :key="item.random" :courseInfo="item.courseInfo" v-if="item.messageType === 'TIMCustomElem'" />
          <div class="progress-mask" :style="'height: ' + (100 - item.uploadProgress) + '%'" v-if="item.showProgress"></div>
        </div>
        <div class="message-progress" v-if="item.isSending">
          <van-loading class="loading-icon" type="spinner" />
          <!-- 上传进度 -->
          <div class="progress-text" v-if="item.showProgress">{{ item.uploadProgress }}%</div>
        </div>
      </div>
    </div>
    <!-- 图片预览 -->
    <div class="image-preview" v-if="showPreview" @click="showPreview = false">
      <img :src="previewImgSrc" alt="">
    </div>
    <div class="no-data-tips" v-if="list.length === 0">{{ $lang.noRecords }}</div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 导入中文语言包
import CourseSuspension from '../components/CourseSuspension.vue'
// import timeHandler from '../utils/time'
import { ImagePreview } from 'vant'
dayjs.locale('zh-cn')
export default {
  components: {
    CourseSuspension
  },
  props: ['list', 'history'],
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  data () {
    return {
      previewImgSrc: '',
      showPreview: false,
      startTime: ''
    }
  },
  methods: {
    // 格式化时间
    formatMessageTime (index) {
      if (!this.list[index].msgTime) {
        return ''
      }
      // 当前时间
      let currentTime = dayjs(this.list[index].msgTime || '')
      // 上一条消息时间
      let preTime = this.list[index - 1] ? dayjs(this.list[index - 1].msgTime || '') : ''
      // 分钟
      const diffMinutes = currentTime.diff(preTime, 'minute')
      //  消息之间间隔小于2分钟 则不展示时间
      if (!preTime || diffMinutes >= 2) {
        if (currentTime.isSame(dayjs(), 'day')) {
          return this.$isShowEnglish ? 'today ' : '今天' + currentTime.format('HH:mm')
        } else if (currentTime.isSame(dayjs().subtract(1, 'day'), 'day')) {
          return this.$isShowEnglish ? 'yesterday ' : '昨天' + currentTime.format('HH:mm')
        } else {
          return currentTime.format('MM-DD HH:mm')
        }
      } else {
        return ''
      }
    },
    // 下载文件消息
    toDownloadFile (item) {
      let url = item.fileUrl
      if (item.fileName.indexOf('.pdf') >= 0) {
        // pdf文件
        window.open(url)
      } else {
        // 非pdf文件
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + url,
          '_blank'
        )
      }
    },
    // 预览图片消息
    previewImg (url) {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        // 手机打开
        let img = []
        img.push(url)
        ImagePreview({
          images: img,
          showIndex: false
        })
      } else {
        // 电脑打开
        this.previewImgSrc = url
        this.showPreview = true
      }
    },
    touchstart (e) {
      try {
        this.startTime = new Date().getTime()
        e.preventDefault()
      } catch (error) {
      }
    },
    touchend (e, index) {
      if (this.history) {
        return
      }
      let now = new Date().getTime()
      if (now - this.startTime > 300) {
        // 长按
        console.log('长按')
        this.$emit('longPress', {e, index})
      } else {
        // 点击
        let item = this.list[index]
        if (item.messageType === 'TIMImageElem') {
          this.previewImg(item.imgUrl)
        } else if (item.messageType === 'TIMFileElem') {
          this.toDownloadFile(item)
        }
      }
      return false
    }
  }
}
</script>

<style lang="less" scoped>
// 聊天区域
.chat-content{
  overflow-y: auto;
  flex: 1;
  padding: 0 16px;
  padding-bottom: 38px;
  background-color: #F9F9F9;
  .chat-item{
    width: 100%;
    .message-time{
      text-align: center;
      color: #999;
      font-size: 12px;
      margin-top: 18px;
    }
    .system-message{
      max-width: fit-content;
      text-align: center;
      margin: 18px auto 0;
      font-size: 10px;
      padding: 4px 8px;
      border-radius: 4px;
      background-color: #dcdcdc;
      color: #fff;
    }
    .message-outer{
      position: relative;
      width: 100%;
      display: flex;
      gap: 8px;
      margin-top: 18px;
      .avatar{
        width: 36px;
        height: 36px;
      }
      .message-detail-box{
        position: relative;
        &>*{
          max-width: 60vw;
        }
        .progress-mask{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, .6);
          border-radius: 1px 8px 8px 8px;
        }
        /deep/.text-message{
          background-color: #fff;
          padding: 8px 12px;
          border-radius: 1px 8px 8px 8px;
          white-space: pre-wrap;
          word-break: break-word;
          a{
            color: #fff;
          }
        }
        .img-message{
          border-radius: 1px 8px 8px 8px;
          border: 1px solid #EFEFEF;
          max-height: 200px;
        }
        .file-message{
          display: flex;
          align-items: center;
          height: 60px;
          background-color: #5cacde;
          border-radius: 1px 8px 8px 8px;
          padding: 0 10px;
          cursor: pointer;
          .el-icon-folder{
            font-size: 40px;
            color: #fff;
            margin-right: 7px;
          }
          .file-name{
            color: #fff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .video-message{
          border-radius: 1px 8px 8px 8px;
          max-height: 400px;
        }
      }
      .message-progress{
        align-self: flex-end;
        padding-bottom: 6px;
        display: flex;
        align-items: center;
        gap: 5px;
        font-size: 10px;
        color: #999;
        .van-loading__spinner{
          width: 12px;
          height: 12px;
        }
      }
      /deep/.course-suspension-container{
        width: 60vw;
      }
      &.right{
        flex-direction: row-reverse;
        .message-detail-box{
          &>*{
            border-radius: 8px 1px 8px 8px;
          }
          .text-message{
            background-color: var(--main-color);
            color: #fff;
          }
        }
      }
    }
  }
  .image-preview{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
    z-index: 1000;
    img{
      // max-height: 396px;
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .no-data-tips{
    color: #999;
    text-align: center;
    margin-top: 40vh;
  }
}
.message-enter-active {
  transition: all 0.5s ease;
}
.message-enter {
  opacity: 0;
  transform: translateX(-30px);
}
.right.message-enter {
  opacity: 0;
  transform: translateY(60px);
}
</style>



// WEBPACK FOOTER //
// src/components/MessageList.vue